import { useCallback } from 'react';
import { useSupplierShippingRatesDeleteMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const { handleSuccess, handleError } = useNotificationMessages();
  const [shippingSpecialRateDelete, { isLoading }] = useSupplierShippingRatesDeleteMutation();

  const onRemoveConfirm = useCallback(
    async (shipping: { id: string | undefined }) => {
      try {
        const { data, error }: any = await shippingSpecialRateDelete({
          id: shipping.id as string,
        });

        if (data?.success) {
          handleSuccess(`The Shipping Rate was successfully deleted.`);
          onDeleteModalClose();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [shippingSpecialRateDelete, handleError, handleSuccess, onDeleteModalClose]
  );

  return {
    onRemoveConfirm,
    isLoading,
  };
};
